export default function IntroRoboticPhoto () {
    return (
        <div className="relative w-full h-full flex-col items-center justify-center">
            {/* object-cover fits the image in balance way */}
            <div className="relative w-full h-screen">
                <img
                    className="flex object-cover object-[80%] md:object-center items-center justify-center w-full h-full"
                    alt="Hands-on engineering kit for education robotics"
                    src="/pictures/introRoboticPhoto.webp"
                />
            </div>

            {/* Dark text overlay */}
            <div className="absolute left-0 top-0 z-10 w-full bg-black/75 px-4 py-2">
                {/* h2, not h1: this renders on the homepage, whose single h1 lives in landing.js */}
                <h2 className="text-2xl font-bold text-white md:text-3xl">
                Robotics Kits For Anyone!
                </h2>
            </div>
        </div>
    )
}